





































































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import Loading from '@/app/components/Common/Loading.vue'
import CommonClass from '@/app/module/common'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'
import SelectFieldSearch from '@/app/components/Plant/SelectFieldSearch.vue'
import SelectFieldHeader from '@/app/components/Plant/SelectFieldHeader.vue'
import Pagination from '@/app/components/Common/Pagination.vue'

@Component({
  components: {
    Loading,
    SelectFieldSearch,
    SelectFieldHeader,
    Pagination
  }
})
export default class FieldSelectModal extends Vue {
  private showLoading: boolean = false
  private notDataMessage: boolean = false
  private isRequesting: boolean = false
  private selectId: any[] = []
  private selectingFieldData: any[] = []
  private currentPage: number = 1

  @Prop() private selectedFieldData!: any
  @Prop() private data!: any
  @Prop() private totalCount!: any

  private get changeData (): any {
    return this.data
  }

  private get changeSelect (): any {
    return this.selectedFieldData
  }

  @Watch('changeSelect')
  getSelectField (val: any) {
    this.selectId = []
    this.selectingFieldData = []
    for (let i in val) {
      this.selectId.push(val[i].field_id)
      this.selectingFieldData.push({
        field_id: val[i].field_id,
        field_name: val[i].field_name,
        area_name: val[i].area_name,
        group_name: val[i].group_name,
        district_name: val[i].district_name,
        field_area: val[i].field_area
      })
    }
  }

  @Watch('changeData')
  getData (val: any) {
    this.showLoading = false
    this.isRequesting = false
    if (this.totalCount === 0) {
      this.notDataMessage = true
    } else {
      this.notDataMessage = false
    }
    this.data = val
  }

  private doSelect (data: any) {
    if (this.selectId.includes(data.field_id)) {
      this.selectingFieldData.push({
        field_id: data.field_id,
        field_name: data.field_name,
        area_name: data.area_name,
        group_name: data.group_name,
        district_name: data.district_name,
        field_area: data.field_area
      })
    } else {
      for (let i in this.selectingFieldData) {
        if (data.field_id === this.selectingFieldData[i].field_id) {
          this.selectingFieldData.splice(parseInt(i), 1)
        }
      }
    }
  }

  private doDecision () {
    this.$store.commit('plantState/setFieldSearchText', '')
    this.changeList()
    this.$emit('select-field', this.selectingFieldData)
  }

  private doCancel () {
    this.selectId = []
    this.$store.commit('plantState/setFieldSearchText', '')
    this.changeList()
    this.$emit('close-modal')
  }

  private dofieldSort (data: string) {
    this.isRequesting = true
    this.showLoading = true
    /* 1ページ目に戻る */
    const pagination: any = this.$refs.pagination
    pagination.resetCurrentPage()
    this.scrollTop()

    let sort = false
    if (data === this.$store.state.plantState.fieldOrderName) {
      if (this.$store.state.plantState.fieldSortAsc === true) {
        sort = false
      } else {
        sort = true
      }
    } else {
      sort = true
    }

    this.$store.commit('plantState/setFieldCurrentPage', 1)
    this.currentPage = this.$store.state.plantState.fieldCurrentPage
    this.$store.commit('plantState/setFieldOrderName', data)
    this.$store.commit('plantState/setFieldSortAsc', sort)
    this.$emit('change-data')
  }

  private changeList () {
    this.isRequesting = true
    this.showLoading = true
    /* 1ページ目に戻る */
    const pagination: any = this.$refs.pagination
    pagination.resetCurrentPage()
    this.scrollTop()

    this.$store.commit('plantState/setFieldCurrentPage', 1)
    this.currentPage = this.$store.state.plantState.fieldCurrentPage
    this.$store.commit('plantState/setFieldOrderName', 'field_name')
    this.$store.commit('plantState/setFieldSortAsc', true)
    this.$emit('change-data')
  }

  destroyed () {
    this.$store.commit('plantState/setFieldSearchText', '')
    this.$store.commit('plantState/setFieldCurrentPage', 1)
    this.$store.commit('plantState/setFieldOrderName', 'field_name')
    this.$store.commit('plantState/setFieldSortAsc', true)
  }

  private scrollTop () : any {
    const masterFieldArea: any = document.getElementById('listContainer')!
    masterFieldArea.scrollTop = 0
  }

  private onPageChange (page: number) {
    if (!this.isRequesting) {
      this.showLoading = true
      this.scrollTop()
      this.$store.commit('plantState/setFieldCurrentPage', page)
      this.currentPage = this.$store.state.plantState.fieldCurrentPage
      this.$emit('change-data')
    }
  }
}
